export const MAX_WIDTH_FULL = '100vw';
export const MAX_WIDTH_90 = '90vw';

export const WIDTH_560 = '560px';
export const WIDTH_500 = '500px';
export const WIDTH_480 = '480px';
export const WIDTH_470 = '470px';
export const WIDTH_460 = '460px';
export const WIDTH_430 = '430px';
export const WIDTH_400 = '400px';
export const WIDTH_360 = '360px';

export const OFFER_DIALOG_WIDTH = '449px';
export const OFFER_DIALOG_MAX_WIDTH = '100vw';
